const eyes = document.querySelectorAll(".ez-icon--view") ?? [];
const eyesOff = document.querySelectorAll(".ez-icon--view-hide") ?? [];
const passwordFields = document.querySelectorAll("input[type=password]") ?? {};

eyes.forEach(function (item, index) {
   item.addEventListener('click', () => {
       item.classList.add("d-none");
       eyesOff[index].classList.remove("d-none");
       passwordFields[index].type = "text";
   });
});

eyesOff.forEach(function (item, index) {
    item.addEventListener('click', () => {
        item.classList.add("d-none");
        eyes[index].classList.remove("d-none");
        passwordFields[index].type = "password";
    });
});
